import { useState, FormEvent } from "react";
import { Page, List, ListInput, Button, Icon, Block, f7 } from "framework7-react";
import { useAuth } from "./AuthProvider";
import './Login.css';

interface FormData {
    username: string;
    password: string;
}

const Login: React.FC = () => {
    const { login } = useAuth();
    const [form, setForm] = useState<FormData>({ username: "", password: "" });

    const handleLogin = async (e: FormEvent) => {
        e.preventDefault();
        if (!form.username || !form.password) {
            f7.dialog.alert("Please fill all fields");
            return;
        }
        const success = await login(form.username, form.password);
        if (success) {
            f7.dialog.alert("Welcome", () => f7.views.main.router.navigate("/"));
        } else {
            f7.dialog.alert("Incorrect data");
        }
    };

    return (
        <Page className='login-page'>
            <Block>
                <div className="text-align-center">
                    <h1 className="text-gray-900 mb-3 fs-3x">
                        Sign In
                    </h1>
                    <div className="text-gray-500 fw-semibold fs-6" data-kt-translate="general-desc">
                        Create powerful Bet Cards to optimise your marketing with more traffic, increased sales and better profits!
                    </div>
                </div>
                <form onSubmit={handleLogin} className="bg-color-white login-page-form">
                    <List strongIos dividersIos insetIos>
                        <ListInput
                            outline
                            label="Email"
                            floatingLabel
                            type="email"
                            placeholder="Your Email"
                            value={form.username}
                            onInput={(e: any) => setForm({ ...form, username: e.target.value })}
                            clearButton
                        >
                            <Icon material="mail" slot="media" />
                        </ListInput>
                        <ListInput
                            outline
                            label="Password"
                            floatingLabel
                            type="password"
                            placeholder="Your password"
                            value={form.password}
                            onInput={(e: any) => setForm({ ...form, password: e.target.value })}
                            clearButton
                        >
                            <Icon f7="lock" slot="media" />
                        </ListInput>
                    </List>
                    <Button preloader type="submit" large fill>
                        Log in
                    </Button>
                </form>
            </Block>
        </Page>
    );
};

export default Login;
